export function validateToken(router) {
  const TOKEN = localStorage.getItem('token');
  if (!TOKEN) {
      router.push({ name: 'user_login' });
      return false; // Token is invalid
  }
  return true; // Token is valid
}
